// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d1835ce3","453":"01ab130e","455":"eb40109a","701":"f5337c23"}[chunkId] + ".chunk.js";
};